import Tree from './tree'

export default Tree



// WEBPACK FOOTER //
// ./src/components/framework/tree/index.js